import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Shell } from "@/components/Shell";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import MarketWatch from "@/pages/MarketWatch";
import InstrumentDetail from "@/pages/InstrumentDetail";
import AdvancedCharts from "@/pages/AdvancedCharts";
import Portfolio from "@/pages/Portfolio";
import RealPortfolio from "@/pages/RealPortfolio";
import SyncMonitor from "@/pages/SyncMonitor";
import TradeValidation from "@/pages/TradeValidation";
import LedgerCompare from "@/pages/LedgerCompare";
import Retention from "@/pages/Retention";
import GTFRegistry from "@/pages/GTFRegistry";
import Deposits from "@/pages/Deposits";
import Journal from "@/pages/Journal";
import RiskManagement from "@/pages/RiskManagement";
import Accounting from "@/pages/Accounting";
import SystemHealth from "@/pages/SystemHealth";
import Brokers from "@/pages/Brokers";
import Notifications from "@/pages/Notifications";
import Settings from "@/pages/Settings";
import UnderDevelopment from "@/pages/UnderDevelopment";
import CryptoMarkets from "@/pages/CryptoMarkets";
import Scanner from "@/pages/Scanner";
import PaperTrading from "@/pages/PaperTrading";
import HoldingsReconciliation from "@/pages/HoldingsReconciliation";
import Backtesting from "@/pages/Backtesting";
import GTFCenter from "@/pages/GTFCenter";
import CapitalAnalytics from "@/pages/CapitalAnalytics";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ErrorBoundary>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <Shell />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/app/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="market-watch" element={<MarketWatch />} />
              <Route path="market-watch/:id" element={<InstrumentDetail />} />
              <Route path="charts" element={<AdvancedCharts />} />
              <Route path="portfolio" element={<Portfolio />} />
              <Route path="real-portfolio" element={<RealPortfolio />} />
              <Route path="sync-monitor" element={<SyncMonitor />} />
              <Route path="trade-validation" element={<TradeValidation />} />
              <Route path="ledger-compare" element={<LedgerCompare />} />
              <Route path="retention" element={<Retention />} />
              <Route path="gtf-registry" element={<GTFRegistry />} />
              <Route path="deposits" element={<Deposits />} />
              <Route path="journal" element={<Journal />} />
              <Route path="risk" element={<RiskManagement />} />
              <Route path="accounting" element={<Accounting />} />
              <Route path="system" element={<SystemHealth />} />
              <Route path="brokers" element={<Brokers />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="settings" element={<Settings />} />
              {/* Under-development modules */}
              <Route path="scanner" element={<Scanner />} />
              <Route path="crypto" element={<CryptoMarkets />} />
              <Route path="opportunities" element={<UnderDevelopment />} />
              <Route path="gtf" element={<GTFCenter />} />
              <Route path="backtesting" element={<Backtesting />} />
              <Route path="paper" element={<PaperTrading />} />
              <Route path="reconciliation" element={<HoldingsReconciliation />} />
              <Route path="live" element={<UnderDevelopment />} />
              <Route path="positions" element={<PaperTrading defaultTab="positions" />} />
              <Route path="orders" element={<PaperTrading defaultTab="orders" />} />
              <Route path="compounding" element={<CapitalAnalytics />} />
              <Route path="analytics" element={<CapitalAnalytics />} />
            </Route>
            <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
          </Routes>
          </ErrorBoundary>
          <Toaster position="top-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
